module.exports = __webpack_public_path__ + "media/images/profile/add-d491f7b0fe01d895956ef06ee8ec4378.svg";